export default __webpack_public_path__ + "static/alerts_screenshot-crop_tell-us-where-to-look-c8fcb561a559a36eb07ff07c4652d53f.webp";